module.exports = __webpack_public_path__ + "static/media/illustraion-generic-help.2571ed5b.svg";